"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var UserSettingsAPI = _interopRequireWildcard(require("crm_data/settings/UserSettingsAPI"));

var _definePooledObjectStore = require("crm_data/flux/definePooledObjectStore");

var _registerPooledObjectService = _interopRequireDefault(require("crm_data/flux/registerPooledObjectService"));

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _ActionNamespaces = require("crm_data/actions/ActionNamespaces");

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

(0, _registerPooledObjectService.default)({
  actionTypePrefix: _ActionNamespaces.USERSETTINGS,
  fetcher: UserSettingsAPI.fetchUserSetting
});

var _default = (0, _definePooledObjectStore.definePooledObjectStore)({
  actionTypePrefix: _ActionNamespaces.USERSETTINGS
}).defineName('UserSettingsStore').defineResponseTo([_ActionTypes.USER_SETTINGS_SAVED, _ActionTypes.USER_SETTINGS_SAVE_FAILED], function (state, payload) {
  var key = payload.key,
      value = payload.value;
  return state.set(key, value);
}).register(_dispatcher.default);

exports.default = _default;
module.exports = exports.default;